<template>
  <discovery-form
    action="create"
    :loading="loading"
    :updating="creating"
    :error-messages="errorMessages"
    :handle-submit="handleFormSubmit"
    :handle-discard="handleDiscard"
  />
</template>

<script>
// eslint-disable-next-line object-curly-newline, no-unused-vars
import { computed, ref, getCurrentInstance } from '@vue/composition-api'

import DiscoveryForm from './discovery-form/DiscoveryForm.vue'

export default {
  components: {
    DiscoveryForm,
  },
  setup() {
    const vm = getCurrentInstance().proxy

    const errorMessages = ref([])

    const loading = ref(false)
    const creating = computed(() => vm.$store.getters['discoveries/creating'])

    const handleFormSubmit = formData => {
      vm.$store
        .dispatch('discoveries/create', formData)
        .then(res => {
          if (res?.status === 200 && res?.data?.data?.discovery) {
            const discoveryId = res.data.data.discovery.id

            vm.$router.replace({
              name: 'discovery-view',
              params: {
                id: discoveryId,
              },
            })
          }
        })
        .catch(err => {
          if (err?.data?.errors) {
            errorMessages.value = err.data.errors
          }
        })
    }

    const handleDiscard = () => vm.$router.replace({ name: 'discovery-list' })

    return {
      loading,
      creating,

      errorMessages,

      handleFormSubmit,
      handleDiscard,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
